import { Grid, ListItem, TextField, Typography } from "@mui/material";
import React, { useState } from "react";
import { InputNumber } from "./InputNumber";
import { SelectCustom } from "./SelectCustom";
import { SelectCustomWithOther } from "./SelectCustomWithOther";
import { TextareaCustom } from "./TextareaCustom";

export const GroupUserWork = (props) => {

    const [autores, setAutores] = useState({
        trabAutores: [{
            autorNombres:'',
            autorApellidos:'',
            autorProcedencia:'',
            autorEmail:'',
        }]
    });
    const { trabAutores } = autores;

    const [resumeTotalWords, setResumeTotalWords] = useState(0);

    const onTrigger = (event) => {
        props.parentCallback(event);
    }

    const onTriggerTotalAutores = (event) => {
        const { target } = event;
        const { name, value } = target;
        
        console.log(name, value);

        if (value > trabAutores.length) {
            // Se agrega un autor
            const newAutor = {
                autorNombres:'',
                autorApellidos:'',
                autorProcedencia:'',
                autorEmail:'',
            }
            trabAutores.push(newAutor);
        } else {
            // Se elimina el ultimo autor
            trabAutores.pop();
        }

        // TODO: Enviar el array de autores para que se actualice en el parent component (simac)

        setAutores({trabAutores});

        const currentWork = props.workTitle;
        const workIndex = currentWork.slice(currentWork.indexOf("-")+1, currentWork.length) - 1;
        // console.log(props.workTitle);   // Sabemos en que trabajo nos encontramos

        props.autoresCallback({workIndex, trabAutores});
        // props.autoresCallback(event);
    }

    const onTriggerAutoresInput = (event) => {
        const { target } = event
        const { name, value } = target;

        console.log(name, value);       // Sabemos el campo y el index+1 del autor

        // Lo que se ingrese se almacena en el elemento correcto del array 'autores'
        const itemName = name.slice(0, name.indexOf("-"));
        const itemIndex = name.slice(name.indexOf("-")+1, name.length) - 1;

        trabAutores[itemIndex][itemName] = value;

        // TODO: Enviar el event al parent component para que alla se maneje la entrada
        // console.log({trabAutores});

        // Obtenemos el index del trabajo actual
        const currentWork = props.workTitle;
        const workIndex = currentWork.slice(currentWork.indexOf("-")+1, currentWork.length) - 1;
        props.autoresCallback({workIndex, trabAutores});
        // props.parentAutoresInputCallback(event);
    }

    const onTriggerResumeInput = (event) => {
        const { target } = event;
        const { value } = target;

        // console.log(name, value);

        // replace -enters- con espacios en blanco (' ') ... devuelve string
        // split en items divididos por (' ') ... devuelve array
        // -> filtra los nulos ('') ... devuelve array
        const totalLength = value.replace('\n', ' ').split(' ').filter( (w) => (w !== '') ).length
        // console.log({totalLength});

        setResumeTotalWords(totalLength);

        /* // -- Ejemplo usando segmenter
        // const tmpText = `I'm like 🫣. But you are, too! 🫵`;
        
        // const segmenter = new Intl.Segmenter( 'en', { granularity: 'word' } );
        // console.log(
        //     Array.from(
        //         segmenter.segment(tmpText),
        //         s => s.segment
        //     )
        // );
        */

        props.parentCallback(event);
    }

    
    return (
        <Grid container spacing={2} sx={{ p: 2 }}>

            <Grid item xs={6}>
                <SelectCustom 
                    parentCallback={onTrigger}
                    name={props.workModality}
                    label={props.workModalityLabel}
                    options={props.workModalityOptions}
                    variant={props.variant}
                />
            </Grid>
            <Grid item xs={6}>
                <InputNumber
                    parentCallback={onTrigger}
                    defaultValue={1}
                    inputProps={{ 
                        min: 1, 
                        onKeyDown: (event) => {
                            event.preventDefault();
                         }
                    }}
                    name={props.workNumParticipaciones}
                    label={props.workNumParticipacionesLabel}
                    paddingH={0}
                    paddingV={0}
                    variant={props.variant}
                    xs={12}
                />
            </Grid>
            <Grid item xs={12}>
                <TextField  
                    defaultValue={""}
                    fullWidth
                    helperText={props.workTitleHelper}
                    id={props.workTitle}
                    label={props.workTitleLabel}
                    name={props.workTitle}
                    onChange={onTrigger}
                    required={props.required}
                    size="small"
                    variant={props.variant}
                />
            </Grid>
            <Grid item xs={12}>
                <SelectCustomWithOther 
                    parentCallback={onTrigger}
                    name={props.workOrientation}
                    label={props.workOrientationLabel}
                    options={props.workOrientationOptions}
                    paddingH={0}
                    variant={props.variant}
                />
            </Grid>
            <Grid item xs={12}>
                <TextareaCustom
                    parentCallback={onTriggerResumeInput}
                    helperText={props.workResumeHelper + (props.workResumeMaxWordsCount - resumeTotalWords)}
                    name={props.workResume}
                    label={props.workResumeLabel}
                    variant={props.variant}
                    inputProps={{ 
                        onKeyDown: (event) => {
                            // "No more keyboard" al alcanzar el maximo de palabras permitidas
                            if ( 
                                (resumeTotalWords === props.workResumeMaxWordsCount)
                                && 
                                (event.key !== "Backspace") && (event.key === " ")
                            ) {
                                event.preventDefault();
                            }
                        }
                    }}
                />
            </Grid> 
            <Grid item xs={12}>
                <TextField  
                    defaultValue={""}
                    fullWidth
                    helperText={props.workKeywordsHelper}
                    id={props.workKeywords}
                    label={props.workKeywordsLabel}
                    name={props.workKeywords}
                    onChange={onTrigger}
                    required={props.required}
                    size="small"
                    variant={props.variant}
                />
            </Grid>

            {/* Total de autores */}
            <Grid item xs={12}>
                <InputNumber
                    parentCallback={onTriggerTotalAutores}
                    defaultValue={1}
                    inputProps={{ 
                        min: 1, 
                        onKeyDown: (event) => {
                            event.preventDefault();
                        }
                    }}
                    label={props.workNumAutoresLabel}
                    name={props.workNumAutores}
                    paddingH={0}
                    paddingV={0}
                    variant={props.variant}
                    xs={6}
                />
            </Grid>
            {/* Datos de los autores */}
            <Grid item xs={12}>
                {trabAutores.map((text, index) => (
                    <ListItem key={index} disablePadding component={'span'}>
                        <Grid container spacing={0} sx={{ m: 1, p: 1, backgroundColor: 'whitesmoke' }}>
                            {/* Nombres y apellidos */}
                            <Grid container spacing={2} >
                                
                                <Grid item xs={2}>
                                    <Typography variant="h5">
                                        {index + 1}{(index === 0 || index === 2) ? 'er.': 'o.'} Autor
                                    </Typography>
                                </Grid>
                                <Grid item xs={5}>
                                    <TextField
                                        defaultValue={props.defaultValue}
                                        fullWidth
                                        id={`autorNombres-${index + 1}`}
                                        label={`Nombres *`}
                                        name={`autorNombres-${index + 1}`}
                                        onChange={onTriggerAutoresInput}
                                        size="small"
                                        variant={'standard'}
                                    />
                                </Grid>
                                <Grid item xs={5}>
                                    <TextField
                                        defaultValue={props.defaultValue}
                                        fullWidth
                                        id={`autorApellidos-${index + 1}`}
                                        label={`Apellidos *`}
                                        name={`autorApellidos-${index + 1}`}
                                        onChange={onTriggerAutoresInput}
                                        size="small"
                                        variant={'standard'}
                                    />
                                </Grid>

                            </Grid>
                            {/* Procedencia, email */}
                            <Grid container spacing={2} >

                                <Grid item xs={7}>
                                    <TextField
                                        defaultValue={props.defaultValue}
                                        fullWidth
                                        id={`autorProcedencia-${index + 1}`}
                                        label={`Institución de procedencia *`}
                                        name={`autorProcedencia-${index + 1}`}
                                        onChange={onTriggerAutoresInput}
                                        size="small"
                                        variant={'standard'}
                                    />
                                </Grid>
                                <Grid item xs={5}>
                                    <TextField
                                        defaultValue={props.defaultValue}
                                        fullWidth
                                        id={`autorEmail-${index + 1}`}
                                        label={`Correo electrónico *`}
                                        name={`autorEmail-${index + 1}`}
                                        onChange={onTriggerAutoresInput}
                                        size="small"
                                        variant={'standard'}
                                    />
                                </Grid>


                            </Grid>
                        </Grid>
                    </ListItem>
                ))}
            </Grid>

        </Grid>
    );
};
